export const demoVideoJSON = [
  {
    id: 1,
    title: "Transform Skid Package Execution with Automation",
    description: `Struggling with delays and cost overruns in skid package projects?
See how ChinookDT's all-in-one automation software connects estimation, engineering, procurement, and fabrication into one seamless workflow.
🚀 Watch the video now and discover how to drive speed, accuracy, and cost control — from proposal to delivery.`,
    link: `/videos/demo/CDT Skid Package.mp4`,
  },
  {
    id: 2,
    title:
      "The Future of Pressure Vessel Engineering: Unified, Automated, and Ready to Deploy",
    description: `Disconnected tools causing delays in your pressure vessel projects?
Watch how ChinookDT unites estimation, engineering, and fabrication in one powerful platform — complete with 4D/5D dashboards and live project control.`,
    link: `/videos/demo/Pressure Vessel Video - Engineering only.mp4`,
  },
  {
    id: 3,
    title:
      "Total Control in Tank Design & Execution — From Drawing to Delivery",
    description: `Designing tanks? Still juggling drawings, Excel sheets, and emails?
Watch our tank software demo and see how ChinookDT unifies design, procurement, and fabrication — complete with 4D/5D dashboards and full material traceability.`,
    link: `/videos/demo/tank software demo - edited.mp4`,
  },
];
